module.exports = __webpack_public_path__ + "media/images/bnr_special_spring-f7ca82ba80d89687393e471394d1f1b7.jpg";